import styled from 'styled-components'
import { VARIABLES } from '../../themes'
// import {
//   default as VARIABLES
// } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const SupplierManagementInformationEditStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  .attached-file-list {
    a {
      &.file-link {
        max-width: 330px;
      }
    }
  }
  .main-content {
    position: relative;
    padding: 67px 60px 20px 60px;
    //min-width: 1450px;
    margin-bottom: 20px;

    .content-body {
      align-content: flex-start;
      align-items: flex-start;

      .form-actions {
        justify-content: space-between;

        .button-group {
          width: auto;

          .remove {
            width: auto;
            padding: 0 15px;
          }
        }
      }
    }

    .contact-detail {
      .table-column {
        padding: 12px 15px 12px 0;

        &.resend-activation-email {
          padding: 0 0 0 30px;
        }
      }
    }
  }

  .loading {
    justify-content: center;
    align-items: center;
  }

  .loader {
    border: 4px solid #3a39a8;
    border-radius: 50%;
    border-top: 4px solid #f3f3f3;
    width: 20px;
    height: 20px;
    margin-left: 45px;
    margin-right: 45px;
    -webkit-animation: spin 2s linear infinite; /* Safari */
    animation: spin 2s linear infinite;
  }

  .offline-comprehensive-assessment-score {
    .data-control {
      gap: 10px 20px;
    }

    .w-10 {
      flex: 0 0 10%;
      align-items: center;
    }

    .flex-column {
      flex-direction: column;
    }

    .row {
      display: flex;
      flex-direction: column;
    }

    .form-control {
      display: flex;
      align-items: center;
      column-gap: 20px;
    }
  }

  .btn-comprehensive-score {
    width: 145px;
    padding: 0 1rem;
  }

  .align-items-center {
    align-items: center;
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (max-width: 1700.98px) {
    .main-content {
      padding: 55px 25px;
    }
  }

  @media all and (max-width: 1600.98px) {
    .main-content {
      padding: 40px 25px;
    }
  }

  @media all and (max-width: 1440.98px) {
    .main-content {
      padding: 30px 20px;
    }
  }

  @media all and (max-width: 1366.98px) {
    .main-content {
      padding: 20px 15px;
    }
  }

  @media all and (max-width: 1280.98px) {
    .main-content {
      padding: 15px;
    }

    .btn-comprehensive-score {
      width: 100px;
    }
  }

  @media all and (max-width: 1024.98px) {
    .main-content {
      padding: 10px;
    }
  }
  @media all and (max-width: 995.98px) {
    .main-content {
      padding: 10px;
    }
    .contact-detail {
      display: table;
      table-layout: fixed;
    }
  }
`
